import da from "../locales/da.json";
import en from "../locales/en.json";
import pl from "../locales/pl.json";
import no from "../locales/no.json";
import se from "../locales/se.json";
import nl from "../locales/nl.json";
export default () => ({
	legacy: false,
	locale: "en_US",
	fallbackLocale: "en_US",
	messages: {
		da_DK: da,
		en_US: en,
		pl_PL: pl,
		nb_NO: no,
		sv_SE: se,
		nl_NL: nl
	}
});
